<!-- 由 woniu6162 创建于 2021-10-22 星期五 -->
<template>
  <div class="p-video">
    <template v-for="(item, index) in datum">
      <div :key="`main${index}`" :class="['pb_item', fBg(item.rank)]">
        <img v-if="item.rank == 1" :src="crownPic" class="pb_ioru_crown" />
        <img
          v-if="fNumPic(item.rank)"
          :src="fNumPic(item.rank)"
          class="pb_i_numpic"
        />
        <div v-else class="pb_i_rank">{{ item.rank }}</div>
        <div class="pb_i_info">
          <div class="pb_ii_video">
            <img :src="item.cover" class="pb_io_pic" />
            <!-- <img
              :src="playPic"
              class="pb_io_play"
              @click="viewVideo(item.share_url)"
            /> -->
            <div
              class="pb_io_copy"
              :data-clipboard-text="item.share_url"
              @click="tapCopy('.pb_io_copy')"
            >
              <i class="iconfont iconlianjie" />
              <div>复制播放链接</div>
            </div>
          </div>
          <div class="pb_io_right">
            <div :class="['pb_ioru_name', item.rank == 1 ? 'pb_ioru_is' : '']">
              {{ item.title }}
            </div>
            <div class="pb_ior_mid">
              {{ `达人 ${item.nickname}` }}
            </div>
            <div class="pb_ioru_time">{{ item.create_time3 }}</div>
            <div class="pb_ior_down">
              <div class="pb_iord_fans">
                {{ `粉丝：${item.total_fans2}` }}
              </div>
              <div v-if="item.producer_name" class="pb_iord_effect">
                {{ `制作：${item.producer_name}` }}
              </div>
            </div>
          </div>
        </div>
        <div class="pb_ior_card">
          <div class="pb_iorc_item">
            <div class="pb_iorc_title">
              <div>播放</div>
              <img :src="hotPic" />
            </div>
            <div class="pb_iorc_num red_color">{{ item.play_count2 }}</div>
          </div>
          <div class="pb_iorc_line" />
          <div class="pb_iorc_item">
            <div class="pb_iorc_title">点赞</div>
            <div class="pb_iorc_num">{{ item.digg_count2 }}</div>
          </div>
          <div class="pb_iorc_line" />
          <div class="pb_iorc_item">
            <div class="pb_iorc_title">评论</div>
            <div class="pb_iorc_num">{{ item.comment_count2 }}</div>
          </div>
          <div class="pb_iorc_line" />
          <div class="pb_iorc_item">
            <div class="pb_iorc_title">转发</div>
            <div class="pb_iorc_num">{{ item.total_forward2 }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
export default {
  name: 'p-video',

  mixins: [],

  components: {},

  props: {
    datum: {},
    rank: { type: Number, default: 3 }
  },

  data() {
    return {
      rank1: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_rank1',
      rank2: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_rank2',
      rank3: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_rank3',
      crownPic: 'https://cdnvue.gymcity.com.cn/uploads/inner_rank_crown',
      hotPic: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_hot',
      playPic: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_play'
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    fNumPic(val) {
      let str
      switch (val) {
        case 1:
          str = this.rank1
          break
        case 2:
          str = this.rank2
          break
        case 3:
          str = this.rank3
          break
        default:
          break
      }
      return str
    },
    // 名次背景色
    fBg(val) {
      let str = ''
      switch (String(val)) {
        case '1':
          str = 'pb_item_one'
          break
        case '2':
          str = 'pb_item_two'
          break
        case '3':
          str = 'pb_item_three'
          break
        default:
          break
      }
      return str
    },
    viewVideo(url) {
      location.href = url
    },
    // 复制
    tapCopy(val) {
      let clipboard = new Clipboard(val)
      clipboard.on('success', () => {
        this.$toast.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$toast.fail('复制失败，请手动复制')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.p-video {
  .pb_item {
    margin: 3.5vw auto 0;
    width: 91.5vw;
    box-sizing: border-box;
    border-radius: 1.1vw;
    padding: 4.3vw 0;
    // box-shadow: 0vw 0vw 1.1vw 0vw rgba(0, 0, 0, 0.06);
    background: #fff;
    position: relative;
    .pb_ioru_crown {
      position: absolute;
      z-index: 1;
      top: 0.8vw;
      left: 27.8vw;
      transform: rotate(30deg);
      width: 6.7vw;
      object-fit: cover;
    }
    .pb_i_numpic {
      position: absolute;
      top: 0;
      left: 0;
      width: 13.3vw;
      height: 13.3vw;
    }
    .pb_i_rank {
      position: absolute;
      left: 3vw;
      top: 16vw;
      width: 5vw;
      text-align: left;
      font-size: 4vw;
      color: rgba(0, 0, 0, 0.5);
    }
    .pb_i_info {
      padding-left: 9.6vw;
      padding-right: 2.7vw;
      box-sizing: border-box;
      display: flex;
      .pb_ii_video {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 22.4vw;
        height: 29.9vw;
        .pb_io_pic {
          position: absolute;
          left: 0;
          top: 0;
          width: 22.4vw;
          height: 29.9vw;
          box-sizing: border-box;
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 0.5vw;
        }
        .pb_io_play {
          width: 10.7vw;
          height: 10.7vw;
          position: relative;
          z-index: 1;
        }
        .pb_io_copy {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2.7vw;
          line-height: 5vw;
          font-weight: 600;
          color: #ffffff;
          position: absolute;
          z-index: 1;
          bottom: 1.9vw;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.3),
            rgba(0, 0, 0, 0.02)
          );
          & > i {
            margin-right: 0.8vw;
            font-size: 3.2vw;
            font-weight: normal;
          }
        }
      }
      .pb_io_right {
        width: 100%;
        margin-left: 2.7vw;
        & > div {
          display: flex;
          align-items: center;
        }
        .pb_ioru_name {
          max-width: 53.1vw;
          font-size: 4vw;
          font-weight: 600;
          color: #000;
          text-align: left;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .pb_ioru_is {
          color: #ff5c5c;
        }
        .pb_ior_mid {
          margin-top: 1.1vw;
          max-width: 53.1vw;
          font-size: 3.2vw;
          color: rgba(0, 0, 0, 0.5);
          font-weight: 600;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .pb_ioru_time {
          margin-top: 1.1vw;
          font-size: 3.5vw;
          color: rgba(0, 0, 0, 0.5);
        }
        .pb_ior_down {
          margin-top: 1.1vw;
          display: flex;
          align-items: center;
          .pb_iord_fans {
            font-size: 3.2vw;
            color: rgba(0, 0, 0, 0.5);
          }
          .pb_iord_effect {
            margin-left: 2.7vw;
            font-size: 3.2vw;
            color: rgba(0, 0, 0, 0.5);
          }
          .pb_iord_hot {
            margin-left: 1.1vw;
            display: flex;
            align-items: center;
            .pb_iordh_pic {
              margin-left: 1.1vw;
              width: 2.1vw;
              object-fit: cover;
            }
            .pb_iordh_force {
              margin-left: 0.5vw;
              font-size: 3.5vw;
              font-weight: 600;
              color: #ff5c5c;
            }
          }
        }
      }
    }
    .pb_ior_card {
      margin-top: 2.7vw;
      margin-left: 9.6vw;
      width: 78.7vw;
      height: 12.5vw;
      // padding: 0 1.1vw;
      box-sizing: border-box;
      background-color: #f7f7f7;
      border-radius: 1.1vw;
      border: solid 0.3vw #f1f1f1;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .pb_iorc_item {
        width: 30%;
      }
      .pb_iorc_line {
        width: 0.3vw;
        height: 7.2vw;
        background: rgba(0, 0, 0, 0.1);
      }
      .pb_iorc_title {
        font-size: 3.2vw;
        color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        & > img {
          margin-left: 1.1vw;
          width: 2.1vw;
          object-fit: cover;
        }
      }
      .pb_iorc_num {
        font-size: 3.5vw;
        font-weight: bold;
        color: #000;
      }
      .red_color {
        color: #ff5c5c;
      }
    }
  }
  .pb_item_one {
    background-image: linear-gradient(180deg, #fffaed 0%, #fff 100%);
    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: -1;
      top: -0.8vw;
      left: -0.8vw;
      right: -0.8vw;
      bottom: -0.8vw;
      border-radius: 1.1vw;
      background: linear-gradient(180deg, #ffe392 0%, #fff 100%);
    }
  }
  .pb_item_two {
    background-image: linear-gradient(180deg, #fff 0%, #fff 100%);
    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: -1;
      top: -0.8vw;
      left: -0.8vw;
      right: -0.8vw;
      bottom: -0.8vw;
      border-radius: 1.1vw;
      background: linear-gradient(180deg, #dcdbdb 0%, #fff 100%);
    }
  }
  .pb_item_three {
    background-image: linear-gradient(180deg, #fff 0%, #fff 100%);
    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: -1;
      top: -0.8vw;
      left: -0.8vw;
      right: -0.8vw;
      bottom: -0.8vw;
      border-radius: 1.1vw;
      background: linear-gradient(180deg, #ffdec4 0%, #fff 100%);
    }
  }
}
</style>
